import * as React from "react";
import Colors from "../../useclass/colors";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { API_BASE_URL, useForceUpdate } from "../../config";
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from "react-redux";
import "../../stylesheets/simulateur.main.css"
import LinkOthersPDF from "../../utils/simulateurs/link.others.PDF";
import roundDecimal from "../../utils/roundDecimal";
import './modal.css';
import close from "../../assets/images/close.png"
import "../../assets/fonts/Roboto/Roboto-Regular.ttf";
import useIsMountedRef from "../../utils/mountedRef";
import Simulateur_42 from "./simulateur.42/simulateur.42";
import Simulateur_105 from "./simulateur.105/simulateur.105";
import Simulateur_104 from "./simulateur.104/simulateur.104";
import Simulateur_103 from "./simulateur.103/simulateur.103";
import Simulateur_106 from "./simulateur.106/simulateur.106";
import Simulateur_113 from "./simulateur.113/simulateur.113";
import Simulateur_116 from "./simulateur.116/simulateur.116";
import PdfViewer from "../../utils/simulateurs/PdfViewer";
import Simulateur_118 from "./simulateur.118/simulateur.118";
import ReactGA from "react-ga4";

function OthersMain(props) {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const currentSimulateurId = props.match.params.simulateur;
    const [nombreConventionHonoraires, setNombreConventionHonoraires] = useState(1);
    const [objectConventionHonoraires, setObjectConventionHonoraires] = useState('');
    const [montantConventionHonoraires, setMontantConventionHonoraires] = useState(0);
    const [nomSignataireConventionHonoraires, setNomSignataireConventionHonoraires] = useState('');
    const [adresseSignataireConventionHonoraires, setAdresseSignataireConventionHonoraires] = useState('');
    const [conventionPdfData, setConventionPdfData] = useState(null);
    const [readyPDF, setReadyPDF] = useState(false)
    const isMountedRef = useIsMountedRef();
    const isMountedRefEmol = useIsMountedRef();
    const [parentSimulateur, setParentSimulateur] = useState({})
    const [departements, setDepartements] = useState("")
    const [createPDF, setCreatePDF] = useState(false)
    const [calculateEsperanceVie, setCalculateEsperanceVie] = useState(false)
    var data = useSelector((state) => state.simulateur);
    

    //var selectorDataStored = useSelector((state) => state.simulateur);
    //const [currentMontant, setCurrentMontant] = useState(0)
    //const [arrayContent, setArrayContent] = useState([])
    const [show, setShow] = useState(false)

    const [simulateurResponse, setSimulateurResponse] = useState([])
    const [remarque, setRemarque] = useState("")


    const [simulateurObject, setSimulateurObject] = useState(
        {
            "data":
            {
                "simulateurid": parentSimulateur.id,
                "departementid": null,
                "inputs": null,
            }
            ,
            "results":
            {
                "output": [],
            }
        }
    )

    useEffect(() => {
        localStorage.setItem("remarque", remarque)
    }, [remarque]);

    useEffect(() => {
        simulateurObject.data.departementid = data.departementid
        localStorage.removeItem("tempo")
    }, [data]);

    useEffect(() => {
        const items = { ...localStorage };
        Object.keys(items).map((key, value) => {
            if (isNumeric(key.toString())) {
                localStorage.removeItem(key)
            }
        })
        localStorage.removeItem("outputAffinage");
        localStorage.removeItem("usageId");
        localStorage.removeItem('nameSimu')
        localStorage.removeItem("conjointSurvivantDMTG")
    }, [isMountedRef]);

    const showHideClassName = show ? "modal display-block" : "modal display-none";

    var forceUpdate = useForceUpdate();


    const getSimulateur = useCallback(() => {
        axios.defaults.withCredentials = true;
        setParentSimulateur({ id: Number(currentSimulateurId), name: "" });
        var config = {
            method: 'get', url: `${API_BASE_URL}/simulateurs/${currentSimulateurId}`, headers: {
                'Content-Type': 'application/json', 'Authorization': JSON.parse(localStorage.getItem("user"))?.jwt,
            },
        };
        axios(config)
            .then((response) => {
                if (response.status === 200 && response.data != null) {
                    if (isMountedRef.current) setParentSimulateur(response.data)
                } else enqueueSnackbar('Une erreur est survenue', {
                    variant: 'error'
                });
            })
            .catch((error) => {
                // 1. Gestion spécifique du 401 / Autre utilisateur connecté
                if (error.response?.status === 401 && error.response.data != null) {
                    if (error.response.data.error == "Other_user_connected" ) {
                        localStorage.removeItem("user")
                        localStorage.setItem("other_user_connected", "other_user_connected")
                        window.location.href = "/login"
                        return;
                    } else {
                        localStorage.removeItem("user");
                        window.location.href = "/login";
                        enqueueSnackbar('Session expirée', {variant: 'error'});
                        return;
                    }
                }

                // 2. Gestion générique de toutes les autres erreurs
                enqueueSnackbar('Une erreur est survenue', {
                    variant: 'error'
                });
            });
    }, [currentSimulateurId, enqueueSnackbar, isMountedRef])

    const styles = {
        container: {
            width: "100%",
            color: Colors.textBlack,
            minHeight: "75vh",
            backgroundColor: Colors.ultraLightGrey,
            fontFamily: "Regular"

        }, container1: {
            display:"flex",
            flexDirection:"row",
            width: "100%",
            color: Colors.textBlack,
            minHeight: "75vh",
            backgroundColor: Colors.ultraLightGrey,
            fontFamily: "Regular"

        }, ctnButton: {
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
            paddingBottom: 30,
            paddingTop: 30,

        }, ctnButtonValide: {
            marginTop: "30px",
            marginLeft: "auto",
            marginRight: "auto",
            // paddingBottom: 30,
            paddingTop: 30,
            textAlign: "center",
            maxWidth: 250

        }, buttonCalculate: {
            display: "block",
            margin: "auto",
            width: "30%",
            height: 35,
            borderRadius: 5,
            border: "none",
            backgroundColor: "#49708C",
            color: Colors.white,
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "2px 2px 1px rgba(0,0,0, 0.2)",
            hover: "#6399BF",

        }, ctnTable: {
            width: "97%",
            marginTop: 10,
            marginBottom: 30,
            backgroundColor: Colors.white,
            //  boxShadow: "2px 2px 1px rgba(0,0,0, 0.2)",
            //width: "95%",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 4,
            minWidth: 400,
        },

        ctnTableData: {
            width: "100%",
            textAlign: "left",
            display: "flex",
            flexDirection: "row",
            height: "100%",
            overflowY: "scroll",
        },

        ctnTableDataElemLeft: {
            width: "100%",
            border: "grey solid 1px",
            borderCollapse: "collapse",
            borderRadiusTopLeft: 3,
            borderRadiusBottomLeft: 3,
            borderRadiusBottomRight: 3,
            height: 35,
            marginBottom: 5

        }, ctnTableDataElemRight: {
            width: "100%",
            borderRight: "grey solid 1px",
            borderTop: "grey solid 1px",
            borderBottom: "grey solid 1px",
            borderCollapse: "collapse",
            borderRadius: 3,
            borderRadiusBottomLeft: 0,
            borderRadiusTopLeft: 0,
            height: 35,

        }, ctnTableDataTxt: {
            lineHeight: 0.5,
            marginLeft: 10,
            fontSize: 16
        },

        table: {
            width: "40%",
            borderCollapse: "collapse",
            marginRight: 5,
            border: "1px solid rgb(238, 236, 236)",
            margin: "auto"
        },

        tr: {
            borderCollapse: "collapse",
            borderRadius: 5,
            fontWeight: "bold",
            textAlign: "center"
        },

        td: {
            borderCollapse: "collapse",
            borderRadius: 5,
            paddingLeft: 10,
            height: 40,
            fontWeight: "bold",
            textAlign: "left",
            borderRight: "1px solid rgb(212, 212, 212)"
        },

        td2: {
            borderCollapse: "collapse",
            borderRadius: 5,
            paddingRight: 10,
            height: 40,
            fontWeight: "bold",
            textAlign: "right",
        },

        th: {
            borderCollapse: "collapse",
            borderRadius: 5,
            paddingLeft: 5,
            height: 45,
            textAlign: "center",
            fontStyle: "italic"
        },

        table2: {
            width: "100%",
            borderCollapse: "collapse",
            marginRight: 5,
            border: "1px solid rgb(238, 236, 236)"
        },

        thead: {
            backgroundColor: "rgb(216, 211, 201)"
        },

        td1form: {
            backgroundColor: "white",
            height: 45,
        },

        td2form: {
            backgroundColor: "rgb(245, 242, 240)",
            height: 45,
        }
    };

    const getDepart = useCallback(() => {
        var config = {
            method: 'get', url: `${API_BASE_URL}/departements`, headers: {
                'Content-Type': 'application/json', 'Authorization': JSON.parse(localStorage.getItem("user"))?.jwt,
            },
        };
        axios(config)
            .then((response) => {
                if (response.status === 200 && response.data != null) {
                    if (isMountedRef.current) {
                        setDepartements(response.data)
                    }
                } else {
                    enqueueSnackbar('Une erreur est survenue', {
                        variant: 'error'
                    });
                }
            })
            .catch((error) => {
                // 1. Gestion spécifique du 401 / Autre utilisateur connecté
                if (error.response?.status === 401 && error.response.data != null) {
                    if (error.response.data.error == "Other_user_connected" ) {
                        localStorage.removeItem("user")
                        localStorage.setItem("other_user_connected", "other_user_connected")
                        window.location.href = "/login"
                        return;
                    } else {
                        localStorage.removeItem("user");
                        window.location.href = "/login";
                        enqueueSnackbar('Session expirée', {variant: 'error'});
                        return;
                    }
                }

                // 2. Gestion générique de toutes les autres erreurs
                enqueueSnackbar('Une erreur est survenue', {
                    variant: 'error'
                });
            });
    }, [isMountedRef])

    useEffect(() => {
        getDepart();
    }, [getDepart]);

    useEffect(() => {
        if (currentSimulateurId === '116') {
            setConventionPdfData(null);
        }
        getSimulateur();
    }, [currentSimulateurId, getSimulateur]);

    useEffect(() => {
        if(parentSimulateur && parentSimulateur.name) {
            localStorage.setItem('nameSimu', parentSimulateur.name)
        }
    }, [parentSimulateur]);

    async function check(data) {
        localStorage.setItem("content", JSON.stringify(data));
        return data
    }

    const handleGenerateConvention = async () => {
        try {
            const departementId = data.departementid;

            if (!departementId) {
                enqueueSnackbar("Veuillez sélectionner un département.", { variant: 'error' });
                return;
            }

            const config = {
                method: 'get',
                url: `${API_BASE_URL}/departement/${departementId}`,
                headers: {
                    'Authorization': JSON.parse(localStorage.getItem("user"))?.jwt,
                }
            };

            const response = await axios(config);
            const tauxTva = response.data.departement_chiffre?.TauxTva;

            if (tauxTva === undefined) {
                enqueueSnackbar("Le taux de TVA n'a pas pu être récupéré pour ce département.", { variant: 'error' });
                return;
            }

            const currUser = JSON.parse(localStorage.getItem("user"));
            if (!currUser) { 
                enqueueSnackbar("Données utilisateur invalides. Veuillez vous reconnecter.", { variant: 'error' });
                return;
            }
            const dataForPdf = {
                pdfInputs: {
                    nombre_convention_honoraires: nombreConventionHonoraires,
                    object_convention_honoraires: objectConventionHonoraires,
                    montant_convention_honoraires: montantConventionHonoraires,
                    nom_signataire_convention_honoraires: nomSignataireConventionHonoraires,
                    adresse_signataire_convention_honoraires: adresseSignataireConventionHonoraires,
                    remarque: localStorage.getItem("remarque") || "",
                    taux_tva: tauxTva,
                },
                currUser: currUser
            };
            setConventionPdfData(dataForPdf);
        } catch (err) {
            console.error("Erreur lors de la récupération du taux de TVA:", err);
            enqueueSnackbar("Un problème est survenu lors de la récupération du taux de TVA.", { variant: 'error' });
        }
    };

    async function calculate118And113() {
        if (parseInt(data.inputs?.type_usufruit) === 1) {
            calculate({
                ...simulateurObject.data,
                simulateurid: 113,
                inputs: data.inputs,
            });
            return;
        }

        if ((data.inputs.usufruitier_successif_esp === 0 && !data.inputs.age_usufruitier) || (data.inputs.usufruitier_successif_esp === 1 && (!data.inputs.age_usufruitier_actuel || !data.inputs.age_usufruitier_successif))) {
            enqueueSnackbar("Veuillez indiquer l'âge pour le calcul de l'espérance de vie.", { variant: 'error' });
            return;
        }
        
        const payload118 = {
            simulateurid: 118,
            inputs: {
                usufruitier_successif_esp: data.inputs.usufruitier_successif_esp,
                genre: data.inputs.genre,
                age_usufruitier: data.inputs.age_usufruitier,
                genre_actuel: data.inputs.genre_actuel,
                age_usufruitier_actuel: data.inputs.age_usufruitier_actuel,
                genre_successif: data.inputs.genre_successif,
                age_usufruitier_successif: data.inputs.age_usufruitier_successif,
            }
        };
        try {
            const response118 = await axios.post(`${API_BASE_URL}/calculateur`, payload118, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(localStorage.getItem("user"))?.jwt,
                }
            });

            if (response118.status === 200 && response118.data) {

                const finalInputs = {
                    ...data.inputs,
                    usufruitier_successif: data.inputs.usufruitier_successif_esp,
                    esperance_vie_usufruitier: roundDecimal(response118.data.esperance_de_vie_calculee),
                    esperance_vie_usufruit_actuel: roundDecimal(response118.data.esperance_actuel_calculee),
                    esperance_vie_usufruit_successif: roundDecimal(response118.data.esperance_successif_calculee),
                };

                const payload113 = {
                    ...simulateurObject.data,
                    simulateurid: 113,
                    inputs: finalInputs,
                };
                
                
                calculate(payload113); 
            }

        } catch (err) {
            enqueueSnackbar('Une erreur est survenue lors du calcul de l\'espérance de vie.', { variant: 'error' });
        }
    }
    
    function calculate(payloadOverride = null) {
        const finalPayload = payloadOverride || {
            "inputs": data.inputs,
            "departementid": data.departementid,
            "simulateurid": data.simulateurid
        };
        simulateurObject["data"]["inputs"] = finalPayload.inputs
        simulateurObject["data"]["departementid"] = finalPayload.departementid
        simulateurObject["data"]["simulateurid"] = finalPayload.simulateurid
        const inputs = simulateurObject["data"]
        if (data.simulateurid === 113) {
            const inputs = simulateurObject["data"]["inputs"];
            if (!inputs) {
                enqueueSnackbar('Veuillez remplir les informations du simulateur.', { variant: 'error' });
                return;
            }

            if (!inputs.prix_vente_immeuble || inputs.prix_vente_immeuble <= 0) {
                enqueueSnackbar("Veuillez indiquer la valeur vénale de l'immeuble.", { variant: 'error' });
                return;
            }

            if (!inputs.valeur_locative_brute || inputs.valeur_locative_brute <= 0) {
                enqueueSnackbar("Veuillez indiquer la valeur locative annuelle brute.", { variant: 'error' });
                return;
            }

            if (parseInt(inputs.type_usufruit) === 1) {
                if (!inputs.duree_usufruit || inputs.duree_usufruit <= 0) {
                    enqueueSnackbar("Veuillez indiquer la durée de l’usufruit.", { variant: 'error' });
                    return;
                }
            }

            // USUFRUIT VIAGER (logique existante)
            if (parseInt(inputs.usufruitier_successif) === 0) {
                if (!inputs.esperance_vie_usufruitier || inputs.esperance_vie_usufruitier <= 0) {
                    enqueueSnackbar("Veuillez indiquer l'espérance de vie de l'usufruitier.", { variant: 'error' });
                    return;
                }
            } else if (parseInt(inputs.usufruitier_successif) === 1) {
                if (!inputs.esperance_vie_usufruit_actuel || inputs.esperance_vie_usufruit_actuel <= 0) {
                    enqueueSnackbar("Veuillez indiquer l'espérance de vie de l'usufruitier actuel.", { variant: 'error' });
                    return;
                }
                if (!inputs.esperance_vie_usufruit_successif || inputs.esperance_vie_usufruit_successif <= 0) {
                    enqueueSnackbar("Veuillez indiquer l'espérance de vie de l'usufruitier successif.", { variant: 'error' });
                    return;
                }
            }
        }
        if (data.simulateurid === 118) {
            const inputs = simulateurObject["data"]["inputs"];

            if (!inputs) {
                enqueueSnackbar('Veuillez remplir les informations du simulateur.', { variant: 'error' });
                return;
            }

            if ((inputs.usufruitier_successif_esp === 0 && !inputs.age_usufruitier) || (inputs.usufruitier_successif_esp === 1 && (!inputs.age_usufruitier_actuel || !inputs.age_usufruitier_successif))) {
                enqueueSnackbar("Veuillez indiquer l'âge.", { variant: 'error' });
                return;
            }

        }

        check(simulateurObject["data"]).then(r => {
            localStorage.setItem("requestSimu", JSON.stringify(r))
            var config = {
                method: 'post', url: `${API_BASE_URL}/calculateur`, headers: {
                    'Content-Type': 'application/json', 'Authorization': JSON.parse(localStorage.getItem("user"))?.jwt,
                }, data: r
            };
            axios(config)
                .then((response) => {
                    if (response.status === 200 && response.data != null) {
                        localStorage.setItem("usageId", response.data.usage_id)

                        setSimulateurResponse(response.data)

                        //   simulateurObject["results"]["output"] = (response.data)

                        var allData = []
                        
                        // Ajout du type d'usufruit au début
                         if (data.inputs.type_usufruit !== undefined && data.inputs.type_usufruit !== null) {
                            allData.push({
                                key: "type_usufruit",
                                name: "Type d'usufruit",
                                value: data.inputs.type_usufruit === 0 ? "Viager" : "À durée fixe"
                            });
                        }
                        
                        if (response.data.charges_total !== undefined) {
                            allData.push({
                                key: "charges_total",
                                name: "Total des charges à rembourser",
                                value: roundDecimal(parseFloat(response.data.charges_total), 2).toString() + "€",
                            })
                        }
                        if (response.data.charges_prorata !== undefined) {
                            allData.push({
                                key: "charges_prorata",
                                name: "Prorata de charges de copropriété",
                                value: roundDecimal(parseFloat(response.data.charges_prorata), 2).toString() + "€",
                            })
                        }
                        if (data.inputs.fonds_roulement !== undefined) {
                            allData.push({
                                key: "fonds_roulement",
                                name: "Fonds de roulement",
                                value: roundDecimal(parseFloat(data.inputs.fonds_roulement), 2).toString() + "€",
                            })
                        }
                        if (data.inputs.fond_reserve !== undefined) {
                            allData.push({
                                key: "fond_reserve",
                                name: "Fonds de réserve",
                                value: roundDecimal(parseFloat(data.inputs.fond_reserve), 2).toString() + "€",
                            })
                        }
                        if (data.inputs.fond_travaux !== undefined) {
                            allData.push({
                                key: "fond_travaux",
                                name: "Fonds de travaux",
                                value: roundDecimal(parseFloat(data.inputs.fond_travaux), 2).toString() + "€",
                            })
                        }
                        if (data.inputs.travaux_vote !== undefined) {
                            allData.push({
                                key: "travaux_vote",
                                name: "Montant des travaux votés",
                                value: roundDecimal(parseFloat(data.inputs.travaux_vote), 2).toString() + "€",
                            })
                        }
                        if (data.inputs.depot_garantie !== undefined) {
                            allData.push({
                                key: "depot_garantie",
                                name: "Montant du dépôt de garantie",
                                value: roundDecimal(parseFloat(data.inputs.depot_garantie), 2).toString() + "€",
                            })
                        }
                        if (data.inputs.prorata_loyer !== undefined) {
                            allData.push({
                                key: "prorata_loyer",
                                name: "Montant du prorata des loyers",
                                value: roundDecimal(parseFloat(data.inputs.prorata_loyer), 2).toString() + "€",
                            })
                        }
                        if (response.data.plus_value !== undefined) {
                            allData.push({
                                key: "plus_value",
                                name: "Plus-Value",
                                value: roundDecimal(parseFloat(response.data.plus_value).toString(), 2) + "€",
                            })
                        }
                        if (response.data.taxe_fonciere !== undefined) {
                            allData.push({
                                key: "taxe_fonciere",
                                name: "Prorata de taxe foncière",
                                value: roundDecimal(parseFloat(response.data.taxe_fonciere), 2).toString() + "€",
                            })
                        }
                        if (response.data.total_impots !== undefined) {
                            allData.push({
                                key: "total_impots",
                                name: "Total Impôts",
                                value: roundDecimal(parseFloat(response.data.total_impots), 2).toString() + "€",
                            })
                        }
                        
                        const nombrePersonnes = parseInt(data.inputs.nombre_donateurs) || 1;

                        if (data.inputs.duree_usufruit !== undefined && data.inputs.duree_usufruit !== '' && data.inputs.duree_usufruit > 0) {
                            allData.push({
                                key: "duree_usufruit",
                                name: "Durée de l'usufruit",
                                value: Math.trunc(parseFloat(data.inputs.duree_usufruit)).toString() + " ans"
                            });
                        }

                        // Informations Personne 1
                        if (data.inputs.age_usufruitier_1 !== undefined && data.inputs.age_usufruitier_1 !== '' && data.inputs.age_usufruitier_1 > 0) {
                            allData.push({
                                key: "age_usufruitier_1",
                                name: nombrePersonnes === 2 ? "Âge de la personne 1" : "Âge de l'usufruitier actuel",
                                value: Math.trunc(parseFloat(data.inputs.age_usufruitier_1)).toString() + " ans"
                            });
                        }

                        if (data.inputs.valeur_bien_1 !== undefined && data.inputs.valeur_bien_1 !== '' && data.inputs.valeur_bien_1 > 0) {
                            allData.push({
                                key: "valeur_bien_1",
                                name: nombrePersonnes === 2 ? "Valeur donnée par la personne 1" : "Valeur du bien",
                                value: roundDecimal(parseFloat(data.inputs.valeur_bien_1), 2).toString() + "€"
                            });
                        }

                        if (response.data.taux_usufruit_1 !== undefined) {
                            allData.push({
                                key: "taux_usufruit_1",
                                name: nombrePersonnes === 2 ? "Taux de l'usufruit - Personne 1" : "Taux de l'usufruit",
                                value: roundDecimal(parseFloat(response.data.taux_usufruit_1) * 100, 2).toString() + "%",
                            });
                        }

                        if (response.data.Usufruit_1 !== undefined) {
                            allData.push({
                                key: "Usufruit_1",
                                name: nombrePersonnes === 2 ? "Valeur de l'usufruit - Personne 1" : "Valeur de l'usufruit",
                                value: roundDecimal(parseFloat(response.data.Usufruit_1), 2).toString() + "€",
                            });
                        }

                        if (response.data.taux_nue_propriete_1 !== undefined) {
                            allData.push({
                                key: "taux_nue_propriete_1",
                                name: nombrePersonnes === 2 ? "Taux de la nue-propriété - Personne 1" : "Taux de la nue-propriété",
                                value: roundDecimal(parseFloat(response.data.taux_nue_propriete_1) * 100, 2).toString() + "%",
                            });
                        }

                        if (response.data.Nue_propriete_1 !== undefined) {
                            allData.push({
                                key: "Nue_propriete_1",
                                name: nombrePersonnes === 2 ? "Valeur de la nue-propriété - Personne 1" : "Valeur de la nue-propriété",
                                value: roundDecimal(parseFloat(response.data.Nue_propriete_1), 2).toString() + "€",
                            });
                        }

                        // Informations Personne 2 (s'il y a 2 personnes)
                        if (nombrePersonnes === 2) {
                            if (data.inputs.age_usufruitier_2 !== undefined && data.inputs.age_usufruitier_2 !== '' && data.inputs.age_usufruitier_2 > 0) {
                                allData.push({
                                    key: "age_usufruitier_2",
                                    name: "Âge de la personne 2",
                                    value: Math.trunc(parseFloat(data.inputs.age_usufruitier_2)).toString() + " ans"
                                });
                            }
                            
                            if (data.inputs.valeur_bien_2 !== undefined && data.inputs.valeur_bien_2 !== '' && data.inputs.valeur_bien_2 > 0) {
                                allData.push({
                                    key: "valeur_bien_2",
                                    name: "Valeur donnée par la personne 2",
                                    value: roundDecimal(parseFloat(data.inputs.valeur_bien_2), 2).toString() + "€"
                                });
                            }

                            if (response.data.taux_usufruit_2 !== undefined) {
                                allData.push({
                                    key: "taux_usufruit_2",
                                    name: "Taux de l'usufruit - Personne 2",
                                    value: roundDecimal(parseFloat(response.data.taux_usufruit_2) * 100, 2).toString() + "%",
                                });
                            }

                            if (response.data.Usufruit_2 !== undefined) {
                                allData.push({
                                    key: "Usufruit_2",
                                    name: "Valeur de l'usufruit - Personne 2",
                                    value: roundDecimal(parseFloat(response.data.Usufruit_2), 2).toString() + "€",
                                });
                            }
                            
                            if (response.data.taux_nue_propriete_2 !== undefined) {
                                allData.push({
                                    key: "taux_nue_propriete_2",
                                    name: "Taux de la nue-propriété - Personne 2",
                                    value: roundDecimal(parseFloat(response.data.taux_nue_propriete_2) * 100, 2).toString() + "%",
                                });
                            }

                            if (response.data.Nue_propriete_2 !== undefined) {
                                allData.push({
                                    key: "Nue_propriete_2",
                                    name: "Valeur de la nue-propriété - Personne 2",
                                    value: roundDecimal(parseFloat(response.data.Nue_propriete_2), 2).toString() + "€",
                                });
                            }
                        }

                        if (response.data.montant_mensualites !== undefined) {
                            allData.push({
                                key: "montant_mensualites",
                                name: "Montant des mensualités",
                                value: roundDecimal(parseFloat(response.data.montant_mensualites).toString(), 2) + "€"
                            })
                        }
                        if (response.data.total_interets !== undefined) {
                            allData.push({
                                key: "total_interets",
                                name: "Total des intérêts",
                                value: roundDecimal(parseFloat(response.data.total_interets).toString(), 2) + "€"
                            })
                        }
                        if (response.data.impot_revenu !== undefined) {
                            allData.push({
                                key: "impot_revenu",
                                name: "Dont impôt sur le revenu",
                                value: roundDecimal(parseFloat(response.data.impot_revenu).toString(), 2) + "€"
                            })
                        }
                        if (response.data.prelevements_sociaux !== undefined) {
                            allData.push({
                                key: "prelevements_sociaux",
                                name: "Dont prélèvements sociaux",
                                value: roundDecimal(parseFloat(response.data.prelevements_sociaux), 2).toString() + "€"
                            })
                        }
                        if (response.data.taxe_additionnelle !== undefined) {
                            allData.push({
                                key: "taxe_additionnelle",
                                name: "Dont taxe additionnelle",
                                value: roundDecimal(parseFloat(response.data.taxe_additionnelle), 2).toString() + "€"
                            })
                        }
                        if (response.data.prix_vente !== undefined) {
                            allData.push({
                                key: "prix_vente",
                                name: "Prix de vente",
                                value: roundDecimal(parseFloat(response.data.prix_vente).toString(), 2) + "€"
                            })
                        }
                        if (response.data.prix_net !== undefined) {
                            allData.push({
                                key: "prix_net",
                                name: "Prix net",
                                value: roundDecimal(parseFloat(response.data.prix_net).toString(), 2) + "€"
                            })
                        }
                        if (response.data.honoraires_ht !== undefined) {
                            allData.push({
                                key: "honoraires_ht",
                                name: "Honoraires HT",
                                value: roundDecimal(parseFloat(response.data.honoraires_ht), 2).toString() + "€"
                            })
                        }
                        if (response.data.honoraires_ttc !== undefined) {
                            allData.push({
                                key: "honoraires_ttc",
                                name: "Honoraires TTC",
                                value: roundDecimal(parseFloat(response.data.honoraires_ttc), 2).toString() + "€"
                            })
                        }if (response.data.charges_usufructuaires !== undefined) {
                            allData.push({
                                key: "charges_usufructuaires",
                                name: "Montant total des charges usufructuaires",
                                value: roundDecimal(parseFloat(response.data.charges_usufructuaires), 2).toString() + "€",
                            });
                        }
                        if (response.data.taux_rendement_usufruit !== undefined) {
                            allData.push({
                                key: "taux_rendement_usufruit",
                                name: "Taux de rendement net de charges usufructuaires",
                                value: roundDecimal(parseFloat(response.data.taux_rendement_usufruit), 2).toString() + "%",
                            });
                        }
                        if (response.data.age_fourni !== undefined) {
                            allData.push({
                                key: "age_fourni",
                                name: "Âge usufruitier",
                                value: Math.trunc(parseFloat(response.data.age_fourni)).toString() + " ans",
                            });
                        }
                        if (response.data.genre_fourni === 0) {
                            allData.push({
                                key: "genre_fourni",
                                name: "Genre de l'usufruitier",
                                value: "Homme"
                            });
                        } else if (response.data.genre_fourni === 1) {
                            allData.push({
                                key: "genre_fourni",
                                name: "Genre de l'usufruitier",
                                value: "Femme"
                            });
                        }
                        if (response.data.esperance_de_vie_calculee !== undefined) {
                            allData.push({
                                key: "esperance_de_vie_calculee",
                                name: "Espérance de vie usufruitier",
                                value: roundDecimal(parseFloat(response.data.esperance_de_vie_calculee)).toString() + " ans",
                            });
                        }
                        if (response.data.age_actuel_fourni !== undefined) {
                            allData.push({
                                key: "age_actuel_fourni",
                                name: "Âge de l'usufruitier actuel",
                                value: Math.trunc(parseFloat(response.data.age_actuel_fourni)).toString() + " ans",
                            });
                        }
                        if (response.data.genre_actuel_fourni === 0) {
                            allData.push({
                                key: "genre_actuel_fourni",
                                name: "Genre de l'usufruitier actuel",
                                value: "Homme"
                            });
                        } else if (response.data.genre_actuel_fourni === 1) {
                            allData.push({
                                key: "genre_actuel_fourni",
                                name: "Genre de l'usufruitier actuel",
                                value: "Femme"
                            });
                        }
                        if (response.data.esperance_actuel_calculee !== undefined) {
                            allData.push({
                                key: "esperance_actuel_calculee",
                                name: "Espérance de vie usufruitier actuel",
                                value: roundDecimal(parseFloat(response.data.esperance_actuel_calculee)).toString() + " ans",
                            });
                        }
                        if (response.data.age_successif_fourni !== undefined) {
                            allData.push({
                                key: "age_successif_fourni",
                                name: "Âge de l'usufruitier successif",
                                value: Math.trunc(parseFloat(response.data.age_successif_fourni)).toString() + " ans",
                            });
                        }
                        if (response.data.genre_successif_fourni === 0) {
                            allData.push({
                                key: "genre_successif_fourni",
                                name: "Genre de l'usufruitier successif",
                                value: "Homme"
                            });
                        } else if (response.data.genre_successif_fourni === 1) {
                            allData.push({
                                key: "genre_successif_fourni",
                                name: "Genre de l'usufruitier successif",
                                value: "Femme"
                            });
                        }
                        if (response.data.esperance_successif_calculee !== undefined) {
                            allData.push({
                                key: "esperance_successif_calculee",
                                name: "Espérance de vie usufruitier successif",
                                value: roundDecimal(parseFloat(response.data.esperance_successif_calculee)).toString() + " ans",
                            });
                        }


                        if (response.data.valeur_usufruit !== undefined) {
                            allData.push({
                                key: "valeur_usufruit",
                                name: "Valeur économique de l'usufruit",
                                value: roundDecimal(response.data.valeur_usufruit, 2) + " €"
                            });
                        }

                        if (response.data.valeur_usufruit_actuel !== undefined) {
                            allData.push({
                                key: "valeur_usufruit_actuel",
                                name: "Valeur économique de l'usufruit actuel",
                                value: roundDecimal(response.data.valeur_usufruit_actuel, 2) + " €"
                            });
                        }
                        if (response.data.valeur_usufruit_successif !== undefined) {
                            allData.push({
                                key: "valeur_usufruit_successif",
                                name: "Valeur économique de l'usufruit successif",
                                value: roundDecimal(response.data.valeur_usufruit_successif, 2) + " €"
                            });
                        }

                        if (response.data.valeur_nue_propriété !== undefined) {
                            allData.push({
                                key: "valeur_nue_propriété",
                                name: "Valeur économique de la nue-propriété",
                                value: roundDecimal(response.data.valeur_nue_propriété, 2) + " €"
                            });
                        }
                        
                        if(data.inputs.prix_vente_immeuble !== undefined && data.inputs.prix_vente_immeuble !== '') {
                            allData.push({
                                key: "prix_vente_immeuble",
                                name: "Valeur en pleine propriété de l'immeuble",
                                value: roundDecimal(parseFloat(data.inputs.prix_vente_immeuble), 2).toString() + " €"
                            })
                        }
                    

                        simulateurObject["results"]["output"] = allData
                        //setArrayContent(allData)
                        setCreatePDF(true)
                        //const base64Image = chartRef?.current?.chartInstance?.toBase64Image();

                        showModal()
                    } else {
                        enqueueSnackbar('Une erreur est survenue', {
                            variant: 'error'
                        });
                    }
                })
                .catch((error) => {
                    // 1. Gestion spécifique du 401 / Autre utilisateur connecté
                    if (error.response?.status === 401 && error.response.data != null) {
                        if (error.response.data.error == "Other_user_connected" ) {
                            localStorage.removeItem("user")
                            localStorage.setItem("other_user_connected", "other_user_connected")
                            window.location.href = "/login"
                            return;
                        } else {
                            localStorage.removeItem("user");
                            window.location.href = "/login";
                            enqueueSnackbar('Session expirée', {variant: 'error'});
                            return;
                        }
                    }
                    
                    enqueueSnackbar('Tous les champs n\'ont pas été correctement renseignés.', {
                        variant: 'error'
                    });
                });
        })
    }

    function isNumeric(str) {
        if (typeof str != "string") return false
        return !isNaN(str) && !isNaN(parseFloat(str))
    }

    function showModal() {
        setShow(true)
    }

    function hideModal() {
        setShow(false)
        setReadyPDF(false)
        setCalculateEsperanceVie(false)
    }

    let [objValues, setObjValues] = useState({})


    useEffect(() => {
        objValues = simulateurObject["results"]["output"]

        // tablePrint()
    }, [simulateurObject["results"]["output"]]);

    const resetSimulateurObject = () => {
        setSimulateurObject({
            "data": {
                "simulateurid": parentSimulateur.id,
                "departementid": null,
                "inputs": null,
            },
            "results": {
                "output": [],
            }
        });
    };


    function tablePrint() {


        for (let i = 0; i < simulateurObject["results"]["output"]?.length; i++) {
            objValues[simulateurObject["results"]["output"][`${i}`]["key"]] = simulateurObject["results"]["output"][`${i}`].value.replace('€', '');
        }

        let elem = null
        elem = simulateurObject["results"]["output"]
        // Vérifier s'il y a 2 personnes
        const nombrePersonnes = (data.inputs && data.inputs.nombre_donateurs) ? parseInt(data.inputs.nombre_donateurs) : 1;
        const hasTwoPersons = nombrePersonnes === 2;
        // Vérifier si c'est un simulateur qui demande explicitement le nombre de personnes (simulateur 105)
        const isSimulateurWithNombreDonateurs = data.simulateurid === 105;
        // Vérifier si type_usufruit est présent
        const hasTypeUsufruit = elem && elem.some(item => item.key === "type_usufruit");

        return (<div className={showHideClassName}>
            <div className="modal">
                <div className="modal-main">
                    <>
                        {elem !== undefined ? <div style={styles.ctnTable}>

                            <div style={styles.ctnTableData}>
                                <div style={{ flex: 6 }}>
                                    <p style={{
                                        textAlign: "center", fontSize: 20, fontWeight: "bold"
                                    }}>Résultat de votre simulation</p>

                                    {/* Type d'usufruit commun et centré seulement si présent et pour 2 personnes */}
                                    {hasTypeUsufruit && hasTwoPersons && (() => {
                                        const typeUsufruitItem = elem.find(item => item.key === "type_usufruit");
                                        const dureeUsufruitItem = elem.find(item => item.key === "duree_usufruit");
                                        
                                        if (typeUsufruitItem) {
                                            return (
                                                <div style={{
                                                    width: "94.8%",
                                                    marginLeft: "2.5%",
                                                    marginBottom: "20px"
                                                }}>
                                                    <table style={{
                                                        ...styles.table, 
                                                        width: "100%"
                                                    }}>
                                                        <tbody>
                                                            <tr style={{ backgroundColor: "rgba(94,145,182,0.8)" }}>
                                                                <td style={{
                                                                    ...styles.td,
                                                                    paddingLeft: 10,
                                                                    fontStyle: "",
                                                                    borderRight: "none",
                                                                    textAlign: "center"
                                                                }} colSpan="2">
                                                                    Type d'usufruit : {typeUsufruitItem.value}
                                                                </td>
                                                            </tr>
                                                            {dureeUsufruitItem && (
                                                                <tr style={{ backgroundColor: "rgba(94,145,182,0.8)" }}>
                                                                    <td style={{
                                                                        ...styles.td,
                                                                        paddingLeft: 10,
                                                                        fontStyle: ""
                                                                    }}>
                                                                        Durée de l'usufruit
                                                                    </td>
                                                                    <td style={styles.td2}>
                                                                        {dureeUsufruitItem.value}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            );
                                        }
                                        return null;
                                    })()}

                                    <div style={{
                                        display: (hasTwoPersons || isSimulateurWithNombreDonateurs) ? "flex" : "flex",
                                        flexDirection: (hasTwoPersons || isSimulateurWithNombreDonateurs) ? "row" : "column", 
                                        flexWrap: "wrap",
                                        justifyContent: (hasTwoPersons || isSimulateurWithNombreDonateurs) ? "space-around" : "flex-start",
                                        alignItems: (hasTwoPersons || isSimulateurWithNombreDonateurs) ? "flex-start" : "center",
                                        gap: "30px", /* Espacement entre les tableaux */
                                        padding: "0 10px"
                                    }}>

                                        {(hasTwoPersons || isSimulateurWithNombreDonateurs) ? (
                                            // Affichage pour 2 personnes ou pour simulateur avec nombre_donateurs
                                            <>
                                                {/* Tableau Personne 1 */}
                                                {(() => {
                                                    const person1Data = elem.filter(item => 
                                                        item.key.includes("_1") || 
                                                        (!item.key.includes("_1") && !item.key.includes("_2") && item.key !== "type_usufruit_1" && (hasTwoPersons ? item.key !== "type_usufruit" && item.key !== "duree_usufruit" : true))
                                                    );
                                                    return (
                                                        <div style={{
                                                            width: hasTwoPersons ? "45%" : "45%",
                                                            minWidth: "300px",
                                                            position: "relative",
                                                            margin: hasTwoPersons ? "0" : "0 auto"
                                                        }}>
                                                            {/* Badge uniquement pour 2 personnes */}
                                                            {hasTwoPersons && (
                                                                <div style={{
                                                                    position: "absolute",
                                                                    top: "-15px",
                                                                    left: "50%",
                                                                    transform: "translateX(-50%)",
                                                                    backgroundColor: "rgba(94,145,182,0.9)",
                                                                    color: "white",
                                                                    padding: "8px 20px",
                                                                    borderRadius: "20px",
                                                                    fontWeight: "bold",
                                                                    fontSize: "14px",
                                                                    textTransform: "uppercase",
                                                                    letterSpacing: "1px",
                                                                    boxShadow: "0 4px 15px rgba(94,145,182,0.3)",
                                                                    zIndex: 10
                                                                }}>
                                                                    Personne 1
                                                                </div>
                                                            )}
                                                            <table style={{
                                                                ...styles.table, 
                                                                width: "100%",
                                                                border: "2px solid #4A90E2",
                                                                borderRadius: "8px",
                                                                overflow: "hidden",
                                                                boxShadow: "0 8px 25px rgba(94,145,182,0.15)"
                                                            }}>
                                                                <tbody>
                                                                    {person1Data.map((value, index) => {
                                                                        // Style par défaut pour la première ligne si une seule personne
                                                                        var currentClass = hasTwoPersons ? { backgroundColor: "#F0F8FF" } : 
                                                                                         (index === 0 ? { backgroundColor: "rgba(94,145,182,0.8)" } : { backgroundColor: "#F0F8FF" });
                                                                                         
                                                                        if (value.key == "charges_total") {
                                                                            currentClass = { backgroundColor: "#E6F3FF" }
                                                                        }
                                                                        if (value.key == "charges_prorata" || value.key == "fond_reserve" || value.key == "travaux_vote" || value.key == "prorata_loyer" || value.key == "plus_value") {
                                                                            currentClass = { backgroundColor: "white" }
                                                                        }
                                                                        if (value.key == "fonds_roulement" || value.key == "fond_travaux" || value.key == "depot_garantie") {
                                                                           currentClass = { backgroundColor: "#FFFACD" }
                                                                        }
                                                                        if (value.key == "Usufruit_1" || value.key == "Nue_propriete_1" || value.key == "valeur_bien_1") {
                                                                            currentClass = { backgroundColor: "#E6F3FF" }
                                                                        }
                                                                        if (value.key == "impot_revenu" || value.key == "prelevements_sociaux" || value.key == "taxe_additionnelle" || value.key == "esperance_successif_calculee") {
                                                                            currentClass = { backgroundColor: "#E6F3FF" }
                                                                        }
                                                                        if (value.key == "Emol_total" || value.key == "Major" || value.key == "Emol_Form_Total") {
                                                                            currentClass = { backgroundColor: "rgba(164,148,128,0.8)" }
                                                                        }
                                                                        if (value.key == "taxe_fonciere" || value.key == "total_impots" || value.key == "TVA_total" || value.key == "Tresor_total") {
                                                                            currentClass = { backgroundColor: "rgba(71,143,154,0.73)" }
                                                                        }
                                                                        if (value.key == "Debours_total") {
                                                                            currentClass = { backgroundColor: "rgba(214,127,98,0.71)" }
                                                                        }
                                                                        if (value.key == "Emol_Form") {
                                                                            currentClass["borderBottom"] = "1px solid rgb(238, 236, 236)";
                                                                        }
                                                                        if (value.key == "age_fourni" || value.key == "genre_fourni" || value.key == "age_actuel_fourni" || value.key == "genre_actuel_fourni" || value.key == "age_successif_fourni") {
                                                                            currentClass = { backgroundColor: "white" }
                                                                        }
                                                                        if (value.key == "esperance_de_vie_calculee" || value.key == "esperance_actuel_calculee") {
                                                                            currentClass = { backgroundColor: "rgba(94,145,182,0.8)" }
                                                                        }
                                                                        if (value.key == "genre_successif_fourni") {
                                                                            currentClass = { backgroundColor: "white"  }
                                                                        }
                                                                        if (person1Data[index + 1] !== undefined) {
                                                                            if (person1Data[index + 1].key === "Major") {
                                                                                currentClass["borderBottom"] = "";
                                                                            }
                                                                        }
                                                                        if (value.key == "Major" || value.key == "Tresor_total") {
                                                                            currentClass["borderBottom"] = "1px solid rgb(238, 236, 236)";
                                                                        }
                                                                        simulateurObject["results"]["output"] = elem

                                                                        return (<>
                                                                            <tr style={currentClass}>
                                                                                <td style={{
                                                                                    ...styles.td,
                                                                                    paddingLeft: value.key == "Major" || value.key == "Emol_Form" ? 25 : 10,
                                                                                    fontStyle: value.key == "Major" || value.key == "Emol_Form" ? "italic" : ""
                                                                                }}>{value.name}</td>
                                                                                <td style={styles.td2}>{value.value}</td>
                                                                            </tr>
                                                                        </>)
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    );
                                                })()}

                                                {/* Tableau Personne 2 - uniquement s'il y a 2 personnes */}
                                                {hasTwoPersons && (() => {
                                                    const person2Data = elem.filter(item => 
                                                        item.key.includes("_2") && 
                                                        item.key !== "duree_usufruit" && 
                                                        item.key !== "type_usufruit_2"
                                                    );
                                                    return (
                                                        <div style={{
                                                            width: "45%",
                                                            minWidth: "300px",
                                                            position: "relative"
                                                        }}>
                                                            <div style={{
                                                                position: "absolute",
                                                                top: "-15px",
                                                                left: "50%",
                                                                transform: "translateX(-50%)",
                                                                backgroundColor: "rgba(94,145,182,0.9)",
                                                                color: "white",
                                                                padding: "8px 20px",
                                                                borderRadius: "20px",
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                                textTransform: "uppercase",
                                                                letterSpacing: "1px",
                                                                boxShadow: "0 4px 15px rgba(94,145,182,0.3)",
                                                                zIndex: 10
                                                            }}>
                                                                Personne 2
                                                            </div>
                                                            <table style={{
                                                                ...styles.table, 
                                                                width: "100%",
                                                                border: "2px solid #4A90E2",
                                                                borderRadius: "8px",
                                                                overflow: "hidden",
                                                                boxShadow: "0 8px 25px rgba(94,145,182,0.15)"
                                                            }}>
                                                                <tbody>
                                                                    {person2Data.map((value, index) => {
                                                                        var currentClass = { backgroundColor: "#F0F8FF" };
                                                                        if (value.key == "charges_total") {
                                                                            currentClass = { backgroundColor: "#E6F3FF" }
                                                                        }
                                                                        if (value.key == "charges_prorata" || value.key == "fond_reserve" || value.key == "travaux_vote" || value.key == "prorata_loyer" || value.key == "plus_value") {
                                                                            currentClass = { backgroundColor: "white" }
                                                                        }
                                                                        if (value.key == "fonds_roulement" || value.key == "fond_travaux" || value.key == "depot_garantie") {
                                                                           currentClass = { backgroundColor: "#FFFACD" }
                                                                        }
                                                                        if (value.key == "Usufruit_2" || value.key == "Nue_propriete_2" || value.key == "valeur_bien_2") {
                                                                            currentClass = { backgroundColor: "#E6F3FF" }
                                                                        }
                                                                        if (value.key == "impot_revenu" || value.key == "prelevements_sociaux" || value.key == "taxe_additionnelle" || value.key == "esperance_successif_calculee") {
                                                                            currentClass = { backgroundColor: "#E6F3FF" }
                                                                        }
                                                                        if (value.key == "Emol_total" || value.key == "Major" || value.key == "Emol_Form_Total") {
                                                                            currentClass = { backgroundColor: "rgba(164,148,128,0.8)" }
                                                                        }
                                                                        if (value.key == "taxe_fonciere" || value.key == "total_impots" || value.key == "TVA_total" || value.key == "Tresor_total") {
                                                                            currentClass = { backgroundColor: "rgba(71,143,154,0.73)" }
                                                                        }
                                                                        if (value.key == "Debours_total") {
                                                                            currentClass = { backgroundColor: "rgba(214,127,98,0.71)" }
                                                                        }
                                                                        if (value.key == "Emol_Form") {
                                                                            currentClass["borderBottom"] = "1px solid rgb(238, 236, 236)";
                                                                        }
                                                                        if (value.key == "age_fourni" || value.key == "genre_fourni" || value.key == "age_actuel_fourni" || value.key == "genre_actuel_fourni" || value.key == "age_successif_fourni") {
                                                                            currentClass = { backgroundColor: "white" }
                                                                        }
                                                                        if (value.key == "esperance_de_vie_calculee" || value.key == "esperance_actuel_calculee") {
                                                                            currentClass = { backgroundColor: "rgba(94,145,182,0.8)" }
                                                                        }
                                                                        if (value.key == "genre_successif_fourni") {
                                                                            currentClass = { backgroundColor: "white"  }
                                                                        }
                                                                        if (person2Data[index + 1] !== undefined) {
                                                                            if (person2Data[index + 1].key === "Major") {
                                                                                currentClass["borderBottom"] = "";
                                                                            }
                                                                        }
                                                                        if (value.key == "Major" || value.key == "Tresor_total") {
                                                                            currentClass["borderBottom"] = "1px solid rgb(238, 236, 236)";
                                                                        }
                                                                        simulateurObject["results"]["output"] = elem

                                                                        return (<>
                                                                            <tr style={currentClass}>
                                                                                <td style={{
                                                                                    ...styles.td,
                                                                                    paddingLeft: value.key == "Major" || value.key == "Emol_Form" ? 25 : 10,
                                                                                    fontStyle: value.key == "Major" || value.key == "Emol_Form" ? "italic" : ""
                                                                                }}>{value.name}</td>
                                                                                <td style={styles.td2}>{value.value}</td>
                                                                            </tr>
                                                                        </>)
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    );
                                                })()}
                                            </>
                                        ) : (
                                            // Style par défaut pour les autres simulateurs
                                            <div style={{
                                                width: "45%",
                                                minWidth: "300px",
                                                position: "relative",
                                                margin: "0 auto",
                                            }}>
                                                <table style={{
                                                    ...styles.table,
                                                    width: "100%",
                                                    border: "2px solid #4A90E2",
                                                    borderRadius: "8px",
                                                    overflow: "hidden",
                                                    boxShadow: "0 8px 25px rgba(94,145,182,0.15)"
                                                }}>

                                                    <tbody>
                                                        {
                                                            elem !== undefined ? elem.map((value, index) => {
                                                                var currentClass = index === 0 ? { backgroundColor: "rgba(94,145,182,0.8)" } : { backgroundColor: index % 2 === 0 ? "#E6F3FF" : "#F0F8FF" };
                                                                if (value.key == "Emol_Form") {
                                                                    currentClass["borderBottom"] = "1px solid rgb(238, 236, 236)";
                                                                }
                                                                if (elem[index + 1] !== undefined) {
                                                                    if (elem[index + 1].key === "Major") {
                                                                        currentClass["borderBottom"] = "";
                                                                    }
                                                                }
                                                                if (value.key == "Major" || value.key == "Tresor_total") {
                                                                    currentClass["borderBottom"] = "1px solid rgb(238, 236, 236)";
                                                                }
                                                                simulateurObject["results"]["output"] = elem

                                                                return (<>
                                                                    <tr style={currentClass}>
                                                                        <td style={{
                                                                            ...styles.td,
                                                                            paddingLeft: value.key == "Major" || value.key == "Emol_Form" ? 25 : 10,
                                                                            fontStyle: value.key == "Major" || value.key == "Emol_Form" ? "italic" : ""
                                                                        }}>{value.name}</td>
                                                                        <td style={styles.td2}>{value.value}</td>
                                                                    </tr>
                                                                </>)
                                                            })

                                                                : <></>}
                                                </tbody>
                                            </table>
                                        </div>
                                        )}
                                    </div>

                                    {buttonPrint()}
                                </div>

                                <img src={`${close}`} style={{
                                    position: "absolute",
                                    fontWeight: "bold",
                                    right: 20,
                                    height: 20,
                                    cursor: "pointer"
                                }} onClick={e => {
                                    setReadyPDF(false)
                                    hideModal()
                                    resetSimulateurObject()
                                }} />
                            </div>

                        </div>


                            : <>
                            </>

                        }

                    </>

                </div>
            </div>
        </div>)
    }


    function buttonPrint() {


        return (<>
            <div style={{ ...styles.ctnButtonValide, width: "50%" }}>

                {createPDF === true ?
                    <LinkOthersPDF simulateurObject={simulateurObject}
                                   ready={readyPDF}
                                   setReadyMain={setReadyPDF}
                    />
                    :
                    <></>
                }
            </div>
        </>)
    }
    
    function printCalculateResult() {
        if (props.match.params.simulateur === '116') {
            return (
                <div style={styles.ctnButton}>
                <button
                style={styles.buttonCalculate}
                onClick={() => {
                    if (typeof window.gtag === "function") {
                    window.gtag("event", "click_generer_convention", {
                        event_category: "BoutonAction",
                        event_label: "Générer la convention",
                    });
                    }
                    handleGenerateConvention();
                }}
                >
                Générer la convention
                </button>
                </div>
            );
        }

        if (parserSimulator().props.children !== "Simulateur non disponible") {
            return (
                <>
                    <div style={styles.ctnButton}>
                        <button
                            style={styles.buttonCalculate}
                            onClick={() => {
                                ReactGA.event({
                                    category: "Formulaire",
                                    action: "Clic bouton calculer Others",
                                    label: "calculer_others"
                                });
                                if (props.match.params.simulateur === '113') {
                                    calculate118And113();
                                } else
                                    calculate()
                            }}
                        >
                            Calculer
                        </button>
                    </div>
                    {tablePrint()}
                </>
            );
        }
        
        return <></>;
    }

    function parserSimulator() {
        switch (props.match.params.simulateur) {
            case "42": {
                return (<>
                    <Simulateur_42
                        simulateur={parentSimulateur}
                        isParent={true}
                        departements={departements}
                    />
                </>)
            }
            case "103": {
                return (<>
                    <Simulateur_103
                        simulateur={parentSimulateur}
                        isParent={true}
                        departements={departements}
                    />
                </>)
            }
            case "104": {
                return (<>
                    <Simulateur_104
                        simulateur={parentSimulateur}
                        isParent={true}
                        departements={departements}
                    />
                </>)
            }
            case "105": {
                return (<>
                    <Simulateur_105
                        simulateur={parentSimulateur}
                        isParent={true}
                        departements={departements}
                    />
                </>)
            }
            case "106": {
                return (<>
                    <Simulateur_106
                        simulateur={parentSimulateur}
                        isParent={true}
                        departements={departements}
                    />
                </>)
            }
            case "113": {
                return (<>
                    <Simulateur_113
                        simulateur={parentSimulateur}
                        isParent={true}
                        departements={departements}
                    />
                </>)
            }
            case "116":{
                return (<>
                    <Simulateur_116
                        simulateur={parentSimulateur}
                        departements={departements}
                        nombreConventionHonoraires={nombreConventionHonoraires}
                        setNombreConventionHonoraires={setNombreConventionHonoraires}
                        objectConventionHonoraires={objectConventionHonoraires}
                        setObjectConventionHonoraires={setObjectConventionHonoraires}
                        montantConventionHonoraires={montantConventionHonoraires}
                        setMontantConventionHonoraires={setMontantConventionHonoraires}
                        nomSignataireConventionHonoraires={nomSignataireConventionHonoraires}
                        setNomSignataireConventionHonoraires={setNomSignataireConventionHonoraires}
                        adresseSignataireConventionHonoraires={adresseSignataireConventionHonoraires}
                        setAdresseSignataireConventionHonoraires={setAdresseSignataireConventionHonoraires}
                    />
                </>)
            }
            case "118": {
                return(<>
                    <Simulateur_118
                        simulateur={parentSimulateur}
                        isParent={true}
                    />
                </>)
            }
            default: {
                return (<h2>Simulateur non disponible</h2>)
            }
        }
    }
    return (
        <div style={styles.container1}>
            <div style={styles.container}>
                {parserSimulator()}
                {printCalculateResult()}
                {conventionPdfData && (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <PdfViewer 
                            data={conventionPdfData.pdfInputs} 
                            currUser={conventionPdfData.currUser}
                            onComplete={() => setConventionPdfData(null)}
                        />
                    </div>
                )}
            </div>
        </div>
    );

}

export default OthersMain;
